
import InvQuoteList from '../invoice/InvQuoteList';

const InvoicesPage = () => <InvQuoteList />;

export default InvoicesPage;
